import produce from 'immer'
import { PartnerOrgStatisticsAction } from '../actions'
import { PartnerOrgStatisticsActionType } from '../action-types'
import { StatisticsOverview } from '../actions/statisticsOverviewActions'

interface IdleState {
    type: 'idle'
}

interface LoadingState {
    type: 'loading'
}

interface ErrorState {
    type: 'error'
    error: string
}

export interface LoadedState {
    type: 'loaded'
    statistics: StatisticsOverview
}

export type PartnerOrgStatisticsState =
    | IdleState
    | LoadingState
    | ErrorState
    | LoadedState

const initialState: PartnerOrgStatisticsState = {
    type: 'idle',
}

const reducer = produce(
    (
        state: PartnerOrgStatisticsState = initialState,
        action: PartnerOrgStatisticsAction
    ): PartnerOrgStatisticsState => {
        switch (action.type) {
            case PartnerOrgStatisticsActionType.PARTNER_ORG_STATISTICS_REQUEST:
                return { type: 'loading' }

            case PartnerOrgStatisticsActionType.PARTNER_ORG_STATISTICS_ERROR:
                return { type: 'error', error: action.payload }

            case PartnerOrgStatisticsActionType.PARTNER_ORG_STATISTICS_SUCCESS:
                return { type: 'loaded', statistics: action.payload }

            default:
                return state
        }
    }
)

export default reducer
